import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.908 30.724.247.245.115.109 3.357 3.356c.146.15.299.3.517.514.116.118.244.244.437.43l.02.02.042.044a6.252 6.252 0 0 0 1.702 1.273 6.445 6.445 0 0 0 1.86.612c.593.098 1.192.152 1.793.16a47.032 47.032 0 0 0 .764.013h9.728c.221 0 .395-.004.778-.014a11.59 11.59 0 0 0 1.78-.16 6.403 6.403 0 0 0 1.856-.61 6.235 6.235 0 0 0 1.588-1.154c.463-.467.85-.999 1.151-1.58a6.674 6.674 0 0 0 .613-1.857c.098-.602.15-1.2.158-1.798.008-.27.012-.523.012-.768V18.441l-.002-.2a29.737 29.737 0 0 0-.01-.586 11.988 11.988 0 0 0-.156-1.77 6.668 6.668 0 0 0-.609-1.855 6.323 6.323 0 0 0-1.157-1.592 6.239 6.239 0 0 0-1.59-1.154 6.4 6.4 0 0 0-1.853-.61 11.01 11.01 0 0 0-1.804-.16c-.36-.01-.534-.014-.756-.014h-9.73c-.146 0-.297.002-.474.006l-.305.008a10.92 10.92 0 0 0-1.784.16 6.309 6.309 0 0 0-3.614 1.947c-.166.157-.315.302-.459.449a24.25 24.25 0 0 0-.51.507l-3.448 3.443a13.48 13.48 0 0 0-.139.135l-.127.126c-.136.132-.222.218-.318.319l-3.08 3.076-.033.033-.042.043-.078.078-.14.142a7.24 7.24 0 0 0-.264.272 9.09 9.09 0 0 0-.722.797c-.216.23-.391.495-.517.785l-.035.094a3.52 3.52 0 0 0 0 2.16l.038.101c.128.288.302.553.515.785.234.283.482.555.742.814l.113.114a22.468 22.468 0 0 0 .273.276l.155.156 3.095 3.099.306.3Zm18.998-12.04a.895.895 0 0 1 1.268 1.263l.01.01-4.037 4.037 3.911 3.905a.893.893 0 1 1-1.132 1.373l-.01.01-4.033-4.023-4.03 4.03-.015-.015a.895.895 0 1 1-1.11-1.393l3.887-3.887-4.04-4.03.017-.017a.893.893 0 1 1 1.385-1.113l3.902 3.895 3.928-3.928a.909.909 0 0 1 .099-.118Z",
    fill: "currentColor"
  }));
};

var SvgKeypadDelete = styled(SvgComponent).withConfig({
  displayName: "KeypadDelete__SvgKeypadDelete",
  componentId: "sc-17wks5v-0"
})(["", " ", ""], size, color);
export default SvgKeypadDelete;